module.exports = __webpack_public_path__ + "static/media/angle-double-left.4b6e9526.svg";